// extracted by mini-css-extract-plugin
module.exports = {"input-row":"InputRow_input-row__1aTs_","horizontal-form":"InputRow_horizontal-form__2T9AB","edited":"InputRow_edited__1rb5F"};